import { render } from "./BoxWithNews.vue?vue&type=template&id=0bda1356&scoped=true&ts=true"
import script from "./BoxWithNews.vue?vue&type=script&lang=ts"
export * from "./BoxWithNews.vue?vue&type=script&lang=ts"

import "./BoxWithNews.vue?vue&type=style&index=0&id=0bda1356&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bda1356"]])

export default __exports__